import { QueueManagementConstants } from '../../queueManagement/QueueManagementConstants';
import { PriorityRuleUtilsService } from './PriorityRuleUtilsService';
import { ToastType } from 'modules/application/misc/ToastService';
export class PriorityRulesService {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN', '$translate', 'BlipToastService'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN, $translate, BlipToastService) {
        'ngInject';
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.$translate = $translate;
        this.BlipToastService = BlipToastService;
    }
    /**
     * Add or update and priority rule to an application
     * @param application
     * @param priorityRule
     */
    async set(application, priorityRule) {
        const resource = {
            ownerIdentity: `${application.shortName}@${this.MESSAGINGHUBDOMAIN}`,
        };
        // tslint:disable-next-line:forin
        for (const prop in priorityRule) {
            resource[prop] = priorityRule[prop];
        }
        return await this.MessagingHubService.sendCommand({
            method: 'set',
            to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
            type: 'application/vnd.iris.desk.priority-rules+json',
            uri: QueueManagementConstants.URL.PRIORITIES,
            resource: resource,
        });
    }
    /**
     * Delete an application priority rule
     * @param priorityRule
     */
    async delete(priorityRule) {
        return await this.MessagingHubService.sendCommand({
            method: 'delete',
            to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
            uri: `${QueueManagementConstants.URL.PRIORITIES}/${priorityRule.id}`,
        });
    }
    /**
     * Get information about certain priority rule
     * @param priorityRuleId - the priority rule's ID
     */
    async getPriorityRule(priorityRuleId) {
        return await this.MessagingHubService.sendCommand({
            method: 'get',
            to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
            uri: `${QueueManagementConstants.URL.PRIORITIES}${priorityRuleId}`,
        });
    }
    /**
     * Get priority rules for this queue
     * @param queueId - the queue's ID
     * @param skip
     * @param take
     */
    async getPriorityRulesQueue(queueId, skip = 0, take = 100) {
        try {
            const { items, total } = await this.MessagingHubService.sendCommand({
                method: 'get',
                to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
                uri: `${QueueManagementConstants.URL.PRIORITIES_QUEUE}${encodeURIComponent(queueId)}?$skip=${skip}&$take=${take}`,
            });
            const priorityRules = this.mapPriorityRules(items);
            return { priorityRules, total };
        }
        catch (e) {
            if (e.code != 67) {
                this.showToast('queue-management.errors.cannotLoadPriorityRules', ToastType.Danger);
            }
            return { priorityRules: [], total: 0 };
        }
    }
    async showToast(messageReference, type) {
        const msg = await this.$translate(messageReference);
        const toastOptions = { msg };
        await this.BlipToastService.show(type, toastOptions);
    }
    mapPriorityRules(items) {
        return items.map(item => {
            let priorityRule;
            priorityRule = {
                conditions: item.conditions ?? [{
                        property: item.property,
                        relation: item.relation,
                        values: item.values,
                        extrasProperty: '',
                    }],
                ...item,
                opened: false,
                operator: item.operator || QueueManagementConstants.DEFAULT_OPERATOR,
                repeatConditionsBody: item.conditions?.length > 1,
            };
            priorityRule.conditions = priorityRule.conditions.map((condition) => {
                if (condition.property?.includes(QueueManagementConstants.EXTRAS)) {
                    const prop = PriorityRuleUtilsService.convertExtras(condition.property);
                    condition.extrasProperty = prop;
                    condition.property = QueueManagementConstants.CONTACT_EXTRAS;
                }
                return condition;
            });
            return priorityRule;
        });
    }
}
PriorityRulesService.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN', '$translate', 'BlipToastService'];
